import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowRight, Sparkles } from "lucide-react";
import { api } from "../lib/api";

const CATEGORIES = [
  { key: "residential", label: "Residential" },
  { key: "commercial", label: "Commercial" },
  { key: "automotive", label: "Automotive" },
  { key: "specialty", label: "Specialty" },
];

export default function ServicesPage() {
  const [services, setServices] = useState([]);
  const [active, setActive] = useState("residential");

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data.services || []));
  }, []);

  const visible = services.filter((s) => s.category === active);

  return (
    <div data-testid="services-page">
      <section className="bg-[#FAF7EE] border-b border-[#EAE3D2]">
        <div className="container-x py-20 md:py-28">
          <div className="overline mb-4">Our Services</div>
          <h1 className="font-serif text-5xl md:text-6xl tracking-tight text-[#111] max-w-3xl">
            Curated cleaning programs for every space, season, and standard.
          </h1>
        </div>
      </section>

      <section className="container-x py-12">
        <div className="flex flex-wrap gap-2 mb-12" data-testid="service-categories">
          {CATEGORIES.map((c) => (
            <button key={c.key} onClick={() => setActive(c.key)}
              className={`px-5 py-2.5 rounded-full text-sm font-medium tracking-wide transition-all ${
                active === c.key ? "bg-[#0B5D3B] text-white shadow-md" : "bg-white border border-[#EAE3D2] text-[#111] hover:border-[#0B5D3B]"
              }`}
              data-testid={`category-${c.key}`}>
              {c.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-20">
          {visible.map((s) => (
            <div key={s.id} id={s.id} className="card-luxe overflow-hidden grid md:grid-cols-5" data-testid={`service-${s.id}`}>
              <div className="md:col-span-2 aspect-[4/3] md:aspect-auto overflow-hidden">
                <img src={s.image} alt={s.name} className="w-full h-full object-cover" />
              </div>
              <div className="md:col-span-3 p-7 flex flex-col">
                <div className="flex items-baseline justify-between mb-2">
                  <h3 className="font-serif text-2xl text-[#111]">{s.name}</h3>
                  <div className="text-[#D4AF37] font-semibold">${s.price_from}–${s.price_to}</div>
                </div>
                <p className="text-sm text-[#4A554E] leading-relaxed mb-4 flex-1">{s.description}</p>
                <div className="flex items-center gap-4 text-xs text-[#7A8A81] mb-5">
                  <span className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" /> {s.duration}</span>
                </div>
                <div className="flex gap-2 flex-wrap">
                  <Link to={`/booking?service=${s.id}`} className="btn-primary text-sm py-2.5 px-5" data-testid={`book-${s.id}`}>
                    Book this service <ArrowRight className="w-4 h-4 ml-2" />
                  </Link>
                  <Link to="/ai-quote" className="text-sm text-[#0B5D3B] font-medium px-4 py-2.5 rounded-full border border-[#EAE3D2] hover:border-[#0B5D3B]">
                    <Sparkles className="w-4 h-4 mr-2 inline" /> AI Quote
                  </Link>
                </div>
              </div>
            </div>
          ))}
          {visible.length === 0 && <div className="text-[#7A8A81]">No services in this category yet.</div>}
        </div>
      </section>
    </div>
  );
}
